import React from 'react'
import Layout from '../../Layout/Layout'
import wira1 from '../../images/wira1.PNG'

import wira2 from '../../images/wira2.PNG'



const WIRA = () => {
  return (
       <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Women Investment Readiness Accelerators Program (WIRA)</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Women Investment Readiness Accelerator (WIRA) is a high-impact
                         capacity-building initiative for women-led businesses in Nigeria. It was funded by
                          the Agence Française de Développement (AFD) and the Development Bank of Nigeria
                           (DBN), with Sterling One Foundation and Moolu Venture Lab as the implementation
                            and technical leads. The program was specifically designed to strengthen 
                            investment readiness by equipping participants with critical business skills,
                             financial literacy, and tailored mentorship. </p>

                             <p className='light'>This intervention was conceptualized to address structural barriers, such
                                 as limited access to finance
                                 and insufficient financial literacy, that persistently restrict the growth 
                                 of women-led enterprises in the country.</p>

                <p className='light'> </p>
               </div>

                <div className='uk-width-1-2@s'>
                 <img src={wira1} />
               </div>
            </div>





   <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                     <img src={wira2} />
               </div>

                <div className='uk-width-1-2@s'>
               <p className='light'>WIRA successfully supported 100 women entrepreneurs,
                 guiding them through a comprehensive, structured 14-module curriculum
                  and personalized coaching. A remarkable and measurable outcome was 
                  the substantial increase in the enterprises' investment readiness
                   status during the program cycle. The readiness level surged from 
                   a low 7% at the program's baseline to an impressive 48% at the 
                   endline assessment. This achievement resulted in 48 women-led 
                   businesses emerging fully investment-ready, having met all financial
                    documentation, compliance, and business model strengthening requirements.</p>


                    <p className='light'>
                        The strong results demonstrate WIRA's effectiveness as a
                         transformative platform for empowering women entrepreneurs
                          and accelerating their path toward sustainable growth. WIRA 
                          serves as a catalytic intervention, actively improving women's 
                          access to finance and successfully expanding the pipeline of 
                          fundable women-led enterprises within Nigeria’s business ecosystem. 
                          The program also aligns strongly with national development goals,
                           including strengthening MSMEs, promoting gender-inclusive economic
                            participation, and advancing gender equity. Ultimately, WIRA contributes 
                            to closing the persistent gender financing gap and unlocking new
                             pathways for inclusive economic development
                    </p>
               </div>
            </div>











        </div>
        </Layout>
  )
}

export default WIRA